var _path, _ellipse, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuincyTourIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3569 8.04878L16.2309 11.1011C16.1975 11.1908 16.1375 11.2682 16.0589 11.3228C15.9803 11.3775 15.8868 11.4067 15.791 11.4067C15.6952 11.4067 15.6017 11.3775 15.5231 11.3228C15.4445 11.2682 15.3845 11.1908 15.3511 11.1011L14.2251 8.04877C14.2013 7.98438 14.1638 7.92588 14.1152 7.87733C14.0666 7.82877 14.0081 7.79137 13.9436 7.76756L10.888 6.64276C10.7982 6.60946 10.7207 6.54952 10.666 6.47097C10.6114 6.39242 10.582 6.29904 10.582 6.20336C10.582 6.10769 10.6114 6.01431 10.666 5.93575C10.7207 5.85721 10.7982 5.79727 10.888 5.76397L13.9436 4.63913C14.008 4.61538 14.0666 4.57795 14.1152 4.5294C14.1638 4.48085 14.2013 4.42234 14.2251 4.35792L15.3511 1.3056C15.3845 1.2159 15.4445 1.13854 15.5231 1.08391C15.6017 1.02929 15.6952 1.00001 15.791 1.00001C15.8868 1.00001 15.9802 1.02929 16.0589 1.08391C16.1375 1.13854 16.1975 1.2159 16.2309 1.3056L17.3569 4.35792C17.3807 4.42235 17.4182 4.48086 17.4668 4.5294C17.5154 4.57795 17.5739 4.61539 17.6384 4.63913L20.694 5.76398C20.7838 5.79728 20.8613 5.85722 20.916 5.93577C20.9707 6.01432 21 6.1077 21 6.20338C21 6.29905 20.9707 6.39243 20.916 6.47098C20.8613 6.54953 20.7838 6.60947 20.694 6.64277L17.6384 7.76757C17.5739 7.79138 17.5154 7.82878 17.4668 7.87733C17.4182 7.92589 17.3807 7.98438 17.3569 8.04878Z",
    stroke: "url(#paint0_linear_17570_1516)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.40975,
    cy: 3.15366,
    rx: 8.40975,
    ry: 3.15366,
    transform: "matrix(-0.70891 -0.705298 -0.70891 0.705298 17.731 16.3311)",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8279 12.5949C17.8279 17.2371 14.0609 21.0003 9.41397 21.0003C4.76706 21.0003 1 17.2371 1 12.5949C1 7.9527 4.76706 4.18945 9.41397 4.18945",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17570_1516",
    x1: 15.791,
    y1: 1.00001,
    x2: 15.791,
    y2: 11.4067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuincyTourIcon);
export default __webpack_public_path__ + "static/media/quincy-tour-icon.953855c309fe661512440f7063b7bb75.svg";
export { ForwardRef as ReactComponent };